module.exports = __webpack_public_path__ + "img/liragutide_4.ca4039a5.jpg";